<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row">
      <h2 class="text-uppercase">Changelog</h2>
      <div v-for="(version, index) in changelog"  :key="index" class="col-12 mt-4">
        <h3 class="">
          {{ version.tag }} - {{ version.date }}
        </h3>
        <ul v-if="version.changes.length > 0" class="list-group list-group-flush">
          <li v-for="(change, index) in version.changes" :key="index" class="list-group-item">
            <template v-if="change.content.length > 0">
              <strong>[{{ change.type }}]:</strong> {{ change.content }}
            </template>
          </li>
        </ul>
      </div>
      <div class="col-12 mt-2">
        <button @click="back" class="col-6 btn btn-bb5-black m-0 p-2">{{ $t('back') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import versionData from '../assets/version.json';

export default {
  name: 'Info',
  data() {
    return {
      changelog: [], // Struktur: [{ tag: 'v1.0.1', date: '2025-03-29', changes: ['CHANGE 1', '...'] }, ...]
    };
  },

  methods: {
    back() {
      this.$router.push('/');
    },
    // Funktion zur Verarbeitung von version.json
    parseVersionData(rawData) {
      const versions = [];
      Object.entries(rawData).forEach(([tag, versionInfo]) => {
        // Daten für jeden Release-Tag hinzufügen
        const changes = [];

        // Feature-Änderungen verarbeiten (falls vorhanden)
        if (versionInfo?.feature) {
          versionInfo.feature.forEach(feat => {
            changes.push({
              type: 'feature', // Typ hinzufügen
              content: feat // Der Inhalt ist jetzt direkt der String
            });
          });
        }

        // Fix-Änderungen verarbeiten (falls vorhanden)
        if (versionInfo?.fix) {
          versionInfo.fix.forEach(fix => {
            changes.push({
              type: 'fix', // Typ hinzufügen
              content: fix // Der Inhalt ist jetzt direkt der String
            });
          });
        }

        // Sonstige Änderungen verarbeiten (falls vorhanden)
        if (versionInfo?.change) {
          versionInfo.change.forEach(change => {
            changes.push({
              type: 'change', // Typ hinzufügen
              content: change // Der Inhalt ist jetzt direkt der String
            });
          });
        }

        // Versionsdaten hinzufügen
        versions.push({
          tag: tag === 'unreleased' ? 'Unreleased' : tag,
          date: versionInfo?.date || (tag === 'unreleased' ? null : 'Unbekannt'),
          changes: changes
        });
      });

      // Sortieren nach Datum (jüngere zuerst, falls Datum vorhanden)
      return versions.sort((a, b) =>
        b.date && a.date ? new Date(b.date) - new Date(a.date) : 0
      );
    }
  },
  created() {
    // version.json-Daten laden und verarbeiten
    this.changelog = this.parseVersionData(versionData);
  },
};
</script>

<style scoped>
</style>